export enum ExpirationType {
    EXPIRED_TIME = 'EXPIRED_TIME',
    LOW_TIME = 'LOW_TIME',
    AVERAGE_TIME = 'AVERAGE_TIME',
    EXTENDED_TIME = 'EXTENDED_TIME',
}

export enum GameModeType {
    DATING = 'DATING',
    BIZZ = 'BIZZ',
    BFF = 'BFF',
}

// map based on MAP_STATE_VOTE in encounters
export enum EncountersActionType {
    LIKE = 'LIKE',
    DISLIKE = 'DISLIKE',
    SUPERSWIPE = 'SUPERSWIPE',
    SUPERSWIPE_INCOMING = 'SUPERSWIPE_INCOMING',
    BACKTRACK = 'BACKTRACK',
}

export enum KeycodeType {
    ARROW_LEFT = 37,
    ARROW_RIGHT = 39,
    ARROW_UP = 38,
    ARROW_DOWN = 40,
    ENTER = 13,
}

export enum SettingsFieldsetType {
    LINKS = 'links',
    ABOUT = 'about',
    HEADLINE = 'headline',
    OCCUPATION = 'occupation',
    EDUCATION = 'education',
    NEW_MESSAGES = 'new-messages',
    NEW_ADMIRERS = 'new-admirers',
    VERIFICATION = 'verification',
    NEW_MATCHES = 'new-matches',
    EXPIRING_MATCHES = 'expiring_matches',
    SOUND = 'sound',
    INTERESTED_IN = 'interested-in',
    AGE = 'age',
    DISTANCE = 'distance',
    SNOOZE = 'snooze',
    LANGUAGE = 'language',
    INSTAGRAM = 'instagram',
    GALLERY = 'gallery',
    LOGOUT = 'logout',
    SPOTIFY = 'spotify',
    ADVERTISING = 'advertising',
    ADVANCED_FILTER = 'advanced-filter',
    MOVE_MAKERS = 'move-makers',
    SHOW_IDENTITY = 'show-identity',
    GENDER = 'gender',
}

export enum ColorGroupBrand {
    PRIMARY = 'PRIMARY',
}

export enum ColorGroupBrandShades {
    PRIMARY_LIGHT = 'PRIMARY_LIGHT',
}

export enum ColorGroupGeneric {
    GENERIC_RED = 'GENERIC_RED',
    GENERIC_PINK = 'GENERIC_PINK',
    GENERIC_YELLOW = 'GENERIC_YELLOW',
    GENERIC_GREEN = 'GENERIC_GREEN',
    GENERIC_PURPLE = 'GENERIC_PURPLE',
    GENERIC_BLUE = 'GENERIC_BLUE',
}

export enum ColorGroupMono {
    WHITE = 'WHITE',
    GRAY_DARK = 'GRAY_DARK',
    GRAY = 'GRAY',
    GRAY_LIGHT = 'GRAY_LIGHT',
}

export enum ColorGroupOthers {
    ERROR = 'ERROR',
}

export enum ColorGroupFeatures {
    BILLING = 'BILLING',
    VERIFICATION = 'VERIFICATION',
    EXTEND = 'EXTEND',
    REMATCH = 'REMATCH',
    BOOST = 'BOOST',
    PREMIUM = 'PREMIUM',
    EXPIRING = 'EXPIRING',
    EXPIRED = 'EXPIRED',
    SPOTLIGHT = 'SPOTLIGHT',
    SUPERSWIPE = 'SUPERSWIPE',
    MATCH = 'MATCH',
    BEELINE = 'BEELINE',
    ICEBREAKER = 'ICEBREAKER',
    BFF = 'BFF',
    BIZZ = 'BIZZ',
}

export enum ColorGroupProviders {
    FACEBOOK = 'FACEBOOK',
    INSTAGRAM = 'INSTAGRAM',
    TWITTER = 'TWITTER',
    TRUSTPILOT = 'TRUSTPILOT',
}

export type ColorGroupAll =
    | ColorGroupBrand
    | ColorGroupBrandShades
    | ColorGroupGeneric
    | ColorGroupMono
    | ColorGroupOthers
    | ColorGroupFeatures
    | ColorGroupProviders;

// for back-campatibilty don't use it in new features
export const ColorGroups = {
    Brand: ColorGroupBrand,
    BrandShades: ColorGroupBrandShades,
    Generic: ColorGroupGeneric,
    Mono: ColorGroupMono,
    Others: ColorGroupOthers,
    Features: ColorGroupFeatures,
    Providers: ColorGroupProviders,
};

export const mapColorToClassname: { [key in ColorGroupAll]: string } = {
    [ColorGroupBrand.PRIMARY]: 'color-primary',
    [ColorGroupBrandShades.PRIMARY_LIGHT]: 'color-primary-light',
    [ColorGroupGeneric.GENERIC_RED]: 'color-generic-red',
    [ColorGroupGeneric.GENERIC_PINK]: 'color-generic-pink',
    [ColorGroupGeneric.GENERIC_YELLOW]: 'color-generic-yellow',
    [ColorGroupGeneric.GENERIC_GREEN]: 'color-generic-green',
    [ColorGroupGeneric.GENERIC_PURPLE]: 'color-generic-purple',
    [ColorGroupGeneric.GENERIC_BLUE]: 'color-generic-blue',
    [ColorGroupMono.WHITE]: 'color-white',
    [ColorGroupMono.GRAY_DARK]: 'color-gray-dark',
    [ColorGroupMono.GRAY]: 'color-gray',
    [ColorGroupMono.GRAY_LIGHT]: 'color-gray-light',
    [ColorGroupOthers.ERROR]: 'color-error',
    [ColorGroupFeatures.BILLING]: 'color-feature-billing',
    [ColorGroupFeatures.VERIFICATION]: 'color-feature-verification',
    [ColorGroupFeatures.EXTEND]: 'color-feature-extend',
    [ColorGroupFeatures.REMATCH]: 'color-feature-rematch',
    [ColorGroupFeatures.BOOST]: 'color-feature-boost',
    [ColorGroupFeatures.PREMIUM]: 'color-feature-premium',
    [ColorGroupFeatures.EXPIRING]: 'color-feature-expiring',
    [ColorGroupFeatures.EXPIRED]: 'color-feature-expired',
    [ColorGroupFeatures.SPOTLIGHT]: 'color-feature-spotlight',
    [ColorGroupFeatures.SUPERSWIPE]: 'color-feature-superswipe',
    [ColorGroupFeatures.MATCH]: 'color-feature-match',
    [ColorGroupFeatures.BEELINE]: 'color-feature-beeline',
    [ColorGroupFeatures.ICEBREAKER]: 'color-feature-icebreaker',
    [ColorGroupFeatures.BFF]: 'color-feature-bff',
    [ColorGroupFeatures.BIZZ]: 'color-feature-bizz',
    [ColorGroupProviders.FACEBOOK]: 'color-provider-facebook',
    [ColorGroupProviders.INSTAGRAM]: 'color-provider-instagram',
    [ColorGroupProviders.TWITTER]: 'color-provider-twitter',
    [ColorGroupProviders.TRUSTPILOT]: 'color-provider-trustpilot',
};

export enum PaymentFeatureVariant {
    BILLING,
    SPOTLIGHT,
    SUPERSWIPE,
    BOOST,
    PREMIUM,
}

export const mapPaymentFeatureVariantToButtonColor: {
    [key in PaymentFeatureVariant]: ColorGroupFeatures;
} = {
    [PaymentFeatureVariant.BILLING]: ColorGroupFeatures.BILLING,
    [PaymentFeatureVariant.SPOTLIGHT]: ColorGroupFeatures.SPOTLIGHT,
    [PaymentFeatureVariant.SUPERSWIPE]: ColorGroupFeatures.SUPERSWIPE,
    [PaymentFeatureVariant.BOOST]: ColorGroupFeatures.BOOST,
    [PaymentFeatureVariant.PREMIUM]: ColorGroupFeatures.PREMIUM,
};
